import Controller from "./colorPicker.controller";
import template from "./colorPicker.html";

const colorPicker = {
  template,
  controller: Controller,
  bindings: {
    title: "@",
    isRequired: "<",
    eventName: "<",
    name: "@",
    resourceMethod: "@",
    resourceMethodName: "@",
    colorObject: "<",
    colorsFetchedEvent: "<",
  },
};

export default colorPicker;



// WEBPACK FOOTER //
// ./src/components/colorPicker/colorPicker.component.js